import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
  FormGroup,
  Input,
} from 'reactstrap';
import FileSaver from 'file-saver';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Moment from 'moment';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit'
import { DatetimePicker } from '../../../commons/controls';
import { Localization } from 'react-widgets';
import momentLocalizer from 'react-widgets-moment';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import QueryEmptyState from '../../../commons/queryempty';
import Loader from '../../../commons/loader';
import Services from './Services';
import HelyszinItem from '../../../components/Jegyezz/HelyszinItem';
import EsemenyItem from '../../../components/Jegyezz/EsemenyItem';
import { PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import JegyvasarlasContent from './JegyvasarlasContent';
import NumberFormatter from '../../../commons/NumberFormatter';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import TimeFormatter from '../../../commons/TimeFormatter';
import Lib from '../../../commons/lib';
import RendelesEloszures from './RendelesEloszures';

Moment.locale('hu');
const localizer = new momentLocalizer(Moment);

const { ExportCSVButton } = CSVExport;

class RendelesekContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL', 'QUERY']
      tableStatus: 'QUERY',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'DATA',
      // ['LOAD', 'DATA', 'NETW']
      viewStatus: 'LOAD',
      // ['LOAD', 'DATA', 'NETW']
      formFizetesStatus: 'DATA',
      // ['FEL', 'MOD']
      formType: 'FEL',
      // DATA
      baseJson: [],
      currentId: undefined,
      currentEmail: '',
      torlesId: undefined,
      torlesJegyId: undefined,
      // MODAL UTILS
      modalForm: false,
      modalView: false,
      modalDelete: false,
      modalJegyDelete: false,
      modalEmail: false,
      modalFizetes: false,
      modalPayment: false,
      modalSztorno: false,
      modalNyugtaMegtekintes: false,
      saveButtonLoading: false,
      deleteButtonLoading: false,
      deleteJegyButtonLoading: false,
      emailButtonLoading: false,
      payButtonLoading: false,
      rendelesButtonLoading: false,
      listazasButtonLoading: false,
      xlsxButtonLoading: false,
      reszletesXlsxButtonLoading: false,
      tovabbButtonLoading: false,
      hasTorlesOka: false,
      sztornoButtonLoading: false,
      // ELOSZURES VALUES
      keresesType: 'NEVMAIL',
      eloszuresFizetesimod: '',
      eloszuresKereses: '',
      eloszuresHelyszin: '',
      eloszuresKezdete: TimeFormatter.formatDate(Moment()),
      eloszuresFizKezdete: null,
      eloszuresVege: null,
      eloszuresFizVege: null,
      eloszuresEloadas: '',
      eloszuresRendelesTipus: '',
      eloszuresRendelesAllapot: '',
      // ELOSZURES UTILS
      eloszuresEloadasOptions: [],
      eloszuresFizetesimodOptions: [],
      rendelesTipusOptions: [],
      rendelesAllapotOptions: [],
      eloszuresHelyszinOptions: [],
      eloszuresHelyszinOptionsData: [],
      // FORM VALUES
      formRendeloNev: '',
      formRendeloEmail: '',
      formRendelesAllapot: '',
      formRendelesSorszam: '',
      formEsemenyKezdete: '',
      formEsemenyNev: '',
      formTerem: '',
      formBizonylatszam: '',
      formMegjegyzes: '',
      formFizetesIdo: null,
      formTorlesOka: '',
      formTorlesJegyOka: '',
      formJegyadatok: [],
      // PAYMENT FORM VALUES
      formFizetestipus: '',
      forFizetestipusOptions: [],
      // HELYI FIZETÉS
      formCurrentHelyszin: null,
      formCurrentEsemeny: null,
      formHelyszinCards: [],
      formEsemenyCards: [],
      rendelesKezdete: TimeFormatter.formatDate(Moment()),
      rendelesVege: TimeFormatter.formatDate(Moment()),
      rendelesCime: '',
      showVasarlas: false,
      showSecondScreen: false,

      nyugtaViewObj: null,
      dataNyugtaLoaded: null,
    };

    this.now = new Date();
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.type !== prevProps.type) {
      if (this.props.type === 'RENDELESEK') {
        this.init();
      }
    }
  }

  hasRole = (roles, checkKarb) => {
    return this.props.globals.hasRole(roles, checkKarb);
  }

  init = () => {
    Services.rendelesInit((err, res) => {
      if (!err) {
        let resTipus = res[0].typ.map(e => <option key={e.name} value={e.name}>{e.caption}</option>);
        let resAllapot = res[0].sta.map(e => <option key={e.name} value={e.name}>{e.caption}</option>);
        let resFizmod = res[0].pty.map(e => <option key={e.id} value={e.id}>{e.nev}</option>);
        let resHelyszin = res[0].loc.map(e => <option key={e.id} value={e.id}>{e.nev}</option>);
        this.setState({
          eloszuresHelyszinOptions: resHelyszin,
          eloszuresHelyszinOptionsData: res[0].loc,
          rendelesTipusOptions: resTipus,
          rendelesAllapotOptions: resAllapot,
          eloszuresFizetesimodOptions: resFizmod
        }, () => {
          if (res[0].loc.length > 0) { // Csak egy helyszin tartozik a user-hez
            this.setState({
              eloszuresHelyszin: res[0].loc[0].id,
            }, () => {
              this.handleInputHelyszinChangeAfterInit(res[0].loc[0].id);
            })
          }
        });
      }
    });
  }

  isNumeric = (value) => {
    return /^-{0,1}\d+$/.test(value);
  }

  getRendelesHelyszin = () => {
    Services.getRendelesHelyszin((err, res) => {
      if (!err) {
        let resHelyszin = res[0].map(e => <option key={e.id} value={e.id}>{e.nev}</option>);
        this.setState({
          eloszuresHelyszin: res[0].length === 1 ? res[0][0].id : '',
          eloszuresHelyszinOptions: resHelyszin,
          eloszuresHelyszinOptionsData: res[0]
        }, () => {
          Services.getRendelesEsemeny(this.getHelyszinArray(this.state.eloszuresHelyszin), this.dateToTimezone(this.state.eloszuresKezdete), this.dateToTimezone(this.state.eloszuresVege), '', (err, res) => {
            if (!err) {
              this.setState({
                eloszuresEloadasOptions: res[0].map(e => <option key={e.id} value={e.id}>{e.nam + ' - ' + e.hna + ' (' + (e.sta ? TimeFormatter.formatLLLL(e.sta) : '') + ')'}</option>),
              });
            }
          });
        });
      }
    });
  }

  toggleFormModal = () => {
    this.setState(prevState => ({ modalForm: !prevState.modalForm }));
  }

  toggleViewModal = () => {
    this.setState(prevState => ({ modalView: !prevState.modalView }));
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete, formTorlesOka: '' }));
  }

  toggleDeleteJegyModal = () => {
    this.setState(prevState => ({ modalJegyDelete: !prevState.modalJegyDelete, formTorlesJegyOka: '' }));
  }

  toggleEmailModal = () => {
    this.setState(prevState => ({ modalEmail: !prevState.modalEmail }));
  }

  togglePaymentModal = () => {
    this.setState(prevState => ({ modalPayment: !prevState.modalPayment }));
  }

  toggleFizetesModal = () => {
    this.setState(prevState => ({ modalFizetes: !prevState.modalFizetes }));
  }

  reOpenFizetesModal = () => {
    this.setState(prevState => ({ modalFizetes: !prevState.modalFizetes }), () => {
      this.setState(prevState => ({ modalFizetes: !prevState.modalFizetes }));
    });
  }

  toggleSecondScreen = () => {
    this.setState(prevState => ({ showSecondScreen: !prevState.showSecondScreen }));
  }

  toggleSztornoModal = () => {
    this.setState(prevState => ({ modalSztorno: !prevState.modalSztorno }));
  }

  toggleNyugtaMegtekintes = () => {
    this.setState(prevState => ({ modalNyugtaMegtekintes: !prevState.modalNyugtaMegtekintes }));
  }

  isEmpty = (object) => {
    if (!object || object === '') return true;
    return false;
  }

  dateToTimezone = (date) => {
    if (!date || date === '') return null;
    return TimeFormatter.formatIso(date);
  }

  clearFormValues = () => {
    let eloszuresHelyszin = (this.state.eloszuresHelyszinOptions.length > 1) ? '' : this.state.eloszuresHelyszin;
    let eloszuresEloadasOptions = (this.state.eloszuresHelyszinOptions.length > 1) ? [] : this.state.eloszuresEloadasOptions;
    this.setState({
      keresesType: 'NEVMAIL',
      eloszuresFizetesimod: '',
      eloszuresKereses: '',
      eloszuresHelyszin: eloszuresHelyszin,
      eloszuresKezdete: TimeFormatter.formatDate(Moment()),
      eloszuresFizKezdete: null,
      eloszuresVege: null,
      eloszuresFizVege: null,
      eloszuresEloadas: '',
      eloszuresRendelesTipus: '',
      eloszuresRendelesAllapot: '',
      eloszuresEloadasOptions: eloszuresEloadasOptions,
    });
  }

  isEloszuresEmpty = () => {
    const {
      eloszuresKereses,
      eloszuresRendelesTipus,
      eloszuresRendelesAllapot,
      eloszuresKezdete,
      eloszuresVege
    } = this.state;
    if (this.isEmpty(eloszuresKezdete) && this.isEmpty(eloszuresVege) &&  this.isEmpty(eloszuresKereses) && this.isEmpty(eloszuresRendelesTipus) && this.isEmpty(eloszuresRendelesAllapot)) {
      return true;
    }
    return false;
  }

  getHelyszinArray = (helyszinid) => {
    let helyszinek = JSON.parse(JSON.stringify(this.state.eloszuresHelyszinOptionsData));
    let helyszin = helyszinek.find(x => x.id == helyszinid);
    if (helyszin && helyszin.ids) return helyszin.ids;
    return [];
  }

  getJegyekText = (ulohely, allohely) => {
    let resultText = '';
    if (allohely > 0) resultText += (allohely + ' db állóhely ')
    if (ulohely > 0) resultText += (ulohely + ' db ülőhely')
    return resultText.trim();
  }

  listRendeles = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      if (true) {
        Services.listRendeles(
          this.emptyOrNull(this.state.eloszuresKereses),
          this.state.keresesType !== 'RENDELES' ? this.emptyOrNull(this.state.eloszuresRendelesTipus) : null,
          this.state.keresesType !== 'RENDELES' ? this.emptyOrNull(this.state.eloszuresRendelesAllapot) : null,
          this.state.keresesType !== 'RENDELES' ? this.getHelyszinArray(this.state.eloszuresHelyszin) : null,
          this.dateToTimezone(this.state.eloszuresKezdete),
          this.dateToTimezone(this.state.eloszuresVege),
          this.state.keresesType !== 'RENDELES' ? this.dateToTimezone(this.state.eloszuresFizKezdete) : null,
          this.state.keresesType !== 'RENDELES' ? this.dateToTimezone(this.state.eloszuresFizVege) : null,
          this.state.keresesType !== 'RENDELES' ? this.emptyOrNull(this.state.eloszuresEloadas) : null,
          this.state.keresesType === 'RENDELES',
          this.state.keresesType !== 'RENDELES' ? this.emptyOrNull(this.state.eloszuresFizetesimod) : null,
          (err, res) => {
            if (!err) {
              let rendelesAdatok = JSON.parse(JSON.stringify(res[0]));
              rendelesAdatok.forEach((rendeles) => {
                rendeles.helyszin = rendeles.ena + '¤' + rendeles.vna + '¤' + rendeles.hna + '¤' + rendeles.sta;
                rendeles.megrendelo = this.getMegrendeloText(rendeles.nam, rendeles.ema);
                rendeles.tipus = (rendeles.ori ? rendeles.ori : '') + ' ' + (rendeles.rot ? rendeles.rot : '');
                rendeles.jegyek = this.getJegyekText(rendeles.rse, rendeles.rst);
              });
              this.setState({
                tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
                baseJson: rendelesAdatok,
              });
            } else {
              this.setState({
                tableStatus: 'NETW'
              });
            }
          });
      } else {
        this.setState({
          tableStatus: 'QUERY'
        });
        this.props.globals.addWarning('Legalább egy szűrési feltétel megadása kötelező!');
      }
    });
  }

  getMegrendeloText = (nam, ema) => {
    if (nam && ema) {
      return nam + ' (' + ema + ')';
    } else if (nam) {
      return nam;
    } else if (ema) {
      return ema;
    }
    return '';
  }

  getRendeles = () => {
    this.setState({
      formStatus: 'LOAD'
    });
    Services.getRendeles(this.state.currentId, (err, res) => {
      if (!err) {
        this.setState({
          formStatus: 'DATA',

          formNevEmailKotelezo: res[0].nevEmailKotelezo,
          formRendeloNev: this.nullToString(res[0].rendeloNev),
          formRendeloEmail: this.nullToString(res[0].rendeloEmail),
          formRendelesAllapot: this.nullToString(res[0].rendelesAllapot),
          formRendelesSorszam: this.nullToString(res[0].rendelesSorszam),
          formEsemenyKezdete: this.nullToString(res[0].esemenyKezdeteS),
          formEsemenyNev: this.nullToString(res[0].esemenyNev),

          formTerem: this.nullToString(res[0].helyszinTerem),
          formBizonylatszam: this.nullToString(res[0].rendelesBizonylatSzam),
          formMegjegyzes: this.nullToString(res[0].rendelesMegjegyzes),
          formRendelesAtutalas: this.nullToString(res[0].rendelesAtutalas),
          formFizetesIdo: res[0].rendelesFizetesIdopont,
          formJegyadatok: res[0].jegyadatok,
          nyugtak: res[0].nyugtak && res[0].nyugtak.beans,
          utolsonormalnyugtaid: res[0].nyugtak && res[0].nyugtak.utolsonormalnyugtaid,
        });
      } else {
        this.setState({
          formStatus: 'NETW'
        });
      }
    });
  }

  getRendelesView = () => {
    this.setState({
      viewStatus: 'LOAD'
    });
    Services.getRendeles(this.state.currentId, (err, res) => {
      if (!err) {
        let fizetettJegy = res[0].jegyadatok.find(x => x.jegyFizetesIdopont !== null);

        this.setState({
          viewStatus: 'DATA',

          formRendeloNev: this.nullToString(res[0].rendeloNev),
          formRendeloEmail: this.nullToString(res[0].rendeloEmail),
          formRendelesAllapot: this.nullToString(res[0].rendelesAllapot),
          formRendelesSorszam: this.nullToString(res[0].rendelesSorszam),
          formEsemenyKezdete: this.nullToString(res[0].esemenyKezdete),
          formEsemenyNev: this.nullToString(res[0].esemenyNev),

          viewRendelesIdopont: this.nullToString(res[0].rendelesIdopont),
          viewRogzitesUser: this.nullToString(res[0].rogzitesUser),
          viewModositasIdopont: this.nullToString(res[0].modositasIdopont),
          viewModositasUser: this.nullToString(res[0].modositasUser),
          viewFizetesIdopont: res[0].jegyadatok && res[0].jegyadatok.length > 0 && fizetettJegy && this.nullToString(fizetettJegy.jegyFizetesIdopont),
          viewFizetesUser: res[0].jegyadatok && res[0].jegyadatok.length > 0 && fizetettJegy && this.nullToString(fizetettJegy.jegyFizetesUser),

          formTerem: this.nullToString(res[0].helyszinTerem),
          formBizonylatszam: this.nullToString(res[0].rendelesBizonylatSzam),
          formMegjegyzes: this.nullToString(res[0].rendelesMegjegyzes),
          formFizetesIdo: res[0].rendelesFizetesIdopont,
          formRendelesAtutalas: this.nullToString(res[0].rendelesAtutalas),
          formJegyadatok: res[0].jegyadatok,
          nyugtak: res[0].nyugtak && res[0].nyugtak.beans,
          utolsonormalnyugtaid: res[0].nyugtak && res[0].nyugtak.utolsonormalnyugtaid,
        });
      } else {
        this.setState({
          viewStatus: 'NETW'
        });
      }
    });
  }

  handleRadioInputChange = (e) => {
    if (e.target) {
      this.setState({
        keresesType: e.target.value
      });
    }
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleOszetettInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    let valueIsNumeric = this.isNumeric(value);
    this.setState({
      [name]: value,
      keresesType: valueIsNumeric ? 'RENDELES' : 'NEVMAIL'
    });
  }

  handleDateInputChange = (e, v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    }, () => {
      if (this.state.eloszuresKezdete, this.state.eloszuresVege);
      this.setState({ eloszuresEloadasOptions: [], eloszuresEloadas: '' }, () => {
        Services.getRendelesEsemeny(this.getHelyszinArray(this.state.eloszuresHelyszin), this.dateToTimezone(this.state.eloszuresKezdete), this.dateToTimezone(this.state.eloszuresVege), '', (err, res) => {
          if (!err) {
            this.setState({
              eloszuresEloadasOptions: res[0].map(elo => <option key={elo.id} value={elo.id}>{elo.nam + ' - ' + elo.hna + ' (' + (elo.sta ? TimeFormatter.formatLLLL(elo.sta) : '') + ')'}</option>),
            });
          }
        });
      })
    });
  }

  handleFizDateInputChange = (e, v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }

  handleFizIdoInputChange = (e, v, name) => {
    this.setState({
      [name]: e
    });
  }

  handleInputHelyszinChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value,
      eloszuresEloadasOptions: [],
      eloszuresEloadas: ''
    }, () => {
      Services.getRendelesEsemeny(this.getHelyszinArray(value), this.dateToTimezone(this.state.eloszuresKezdete), this.dateToTimezone(this.state.eloszuresVege), '', (err, res) => {
        if (!err) {
          this.setState({
            eloszuresEloadasOptions: res[0].map(elo => <option key={elo.id} value={elo.id}>{elo.nam + ' - ' + elo.hna + ' (' + (elo.sta ? TimeFormatter.formatLLLL(elo.sta) : '') + ')'}</option>),
          });
        }
      });
    });
  }

  handleInputHelyszinChangeAfterInit = (helyszinid) => {
    this.setState({
      eloszuresEloadasOptions: [],
      eloszuresEloadas: ''
    }, () => {
      Services.getRendelesEsemeny(this.getHelyszinArray(helyszinid), this.dateToTimezone(this.state.eloszuresKezdete), this.dateToTimezone(this.state.eloszuresVege), '', (err, res) => {
        if (!err) {
          this.setState({
            eloszuresEloadasOptions: res[0].map(e => <option key={e.id} value={e.id}>{e.nam + ' - ' + e.hna + ' (' + (e.sta ? TimeFormatter.formatLLLL(e.sta) : '') + ')'}</option>),
          });
        }
      });
    });
  }

  getFizetesInit = () => {
    this.setState({
      formFizetesStatus: 'LOAD'
    });
    Services.getFizetesInit(this.state.currentId, (err, res) => {
      if (!err) {
        this.setState({
          forFizetestipusOptions: res[0].pty.map(e => <option key={e.name} value={e.name}>{e.caption}</option>),
          formFizetesStatus: 'DATA',
        });
      } else {
        this.setState({
          formFizetesStatus: 'NETW'
        });
      }
    });
  }

  handleEmailClick = (cell) => {
    Services.getEmail(cell, (err, res) => {
      if (!err) {
        this.setState({
          currentId: cell,
          currentEmail: res[0].ema,
          modalEmail: true
        });
      }
    });
  }

  handlePaymentClick = (cell) => {
    Services.checkFiezetes(cell, (err) => {
      if (!err) {
        this.props.globals.route.navigate({
          pathname: `/ui/admin/jegyertekesites/helysziniertekesites/rendeles/${cell}`,
          state: { rendelesId: cell }
        });
      }
    });
    // this.setState({
    //   currentId: cell,
    //   modalPayment: true,
    //   formFizetestipus: ''
    // }, () => {
    //   this.getFizetesInit();
    // });
  }

  handleEditClick = (cell) => {
    this.setState({
      formType: 'MOD',
      currentId: cell,
      modalForm: true
    }, () => {
      this.getRendeles();
    });
  }

  handleViewClick = (cell) => {
    this.setState({
      currentId: cell,
      modalView: true
    }, () => {
      this.getRendelesView();
    });
  }

  handleDeleteClick = (cell) => {
    this.setState({
      torlesId: cell
    }, () => {
      Services.checkRendelesDelete([cell], (err, res) => {
        if (!err) {
          this.setState({
            hasTorlesOka: res[0].result
          }, () => {
            this.toggleDeleteModal();
          });
        }
      });
    });
  }

  handleDeleteJegyClick = (cell) => {
    this.setState({
      torlesJegyId: cell
    }, () => {
      Services.checkJegyDelete([cell], (err, res) => {
        if (!err) {
          this.setState({
            hasTorlesOka: res[0].result
          }, () => {
            this.toggleDeleteJegyModal();
          });
        }
      });
    });
    // Services.deleteRendelesJegy([cell], (err) => {
    //   if (!err) {
    //     this.listRendeles();
    //     this.props.globals.addSuccess('Jegy törölve!');
    //     this.getRendeles();
    //   }
    // });
  }

  handlePrintJegyClick = (cell) => {
    Services.getRendelesPrint1(cell, (err, res) => {
      if (!err) {
        let fileURL = URL.createObjectURL(new Blob([res[0]], { type: 'application/pdf' }));
        this.setState({
          fileURL
        }, () => {
          window.setTimeout(() => {
            window.frames['pdf-area-rendelesek'].focus();
            window.frames['pdf-area-rendelesek'].print();
            window.setTimeout(() => {
              window.close();
            }, 50);
          }, 1000);
        });
        this.props.globals.addSuccess('Jegy nyomtatás!');
      }
    });
  }

  handlePrintJegyekClick = (cell) => {
    Services.getRendelesPrint(cell, (err, res) => {
      if (!err) {
        let fileURL = URL.createObjectURL(new Blob([res[0]], { type: 'application/pdf' }));
        // window.open(fileURL, '_blank');
        // window.print();
        this.setState({
          fileURL
        }, () => {
          window.setTimeout(() => {
            window.frames['pdf-area-rendelesek'].focus();
            window.frames['pdf-area-rendelesek'].print();
            window.setTimeout(() => {
              window.close();
            }, 50);
          }, 1000);
        });
        this.props.globals.addSuccess('Jegy nyomtatás!');
      }
    });
  }

  handlePrintNyugta = (id) => {
    Services.pdfNyugta(id, (err, res) => {
      if (!err) {
        let fileURLNyugta = URL.createObjectURL(new Blob([res[0]], { type: 'application/pdf' }));
        this.setState({
          fileURLNyugta
        }, () => {
          window.setTimeout(() => {
            window.frames['pdf-area-nyugtak'].focus();
            window.frames['pdf-area-nyugtak'].print();
            window.setTimeout(() => {
              window.close();
            }, 50);
          }, 1000);
        });
        this.props.globals.addSuccess('Nyugta nyomtatás!');
      }
    });
  }

  resendEmail = () => {
    this.setState({
      emailButtonLoading: true
    });
    Services.resendEmail(this.state.currentId, this.state.currentEmail, (err) => {
      if (!err) {
        this.toggleEmailModal();
        this.listRendeles();
        this.props.globals.addSuccess('Email újraküldve!');
        this.setState({
          emailButtonLoading: false
        });
      } else {
        this.setState({
          emailButtonLoading: false
        });
      }
    });
  }

  deleteRendeles = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deleteRendeles(this.state.torlesId, this.emptyOrNull(this.state.formTorlesOka), (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.listRendeles();
        this.props.globals.addSuccess('Rendelés törölve!');
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }

  deleteJegy = () => {
    this.setState({
      deleteJegyButtonLoading: true
    });
    Services.deleteRendelesJegy(this.state.torlesJegyId, this.emptyOrNull(this.state.formTorlesJegyOka), (err) => {
      if (!err) {
        this.toggleDeleteJegyModal();
        this.getRendeles();
        this.props.globals.addSuccess('Jegy törölve!');
        this.setState({
          deleteJegyButtonLoading: false
        });
      } else {
        this.setState({
          deleteJegyButtonLoading: false
        });
      }
    });
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  handleNewClick = () => {
    this.setState({
      formType: 'FEL',
      formStatus: 'DATA',
      formRendeloNev: '',
      formRendeloEmail: '',
      formRendelesAllapot: '',
      formRendelesSorszam: '',
      formEsemenyKezdete: '',
      formEsemenyNev: '',
      formTerem: '',
      formBizonylatszam: '',
      formMegjegyzes: '',
      formFizetestipus: ''
    }, () => {
      this.toggleFormModal();
    });
  }

  handleEloadasListazas = () => {
    this.setState({ tovabbButtonLoading: true }, () => {
      this.setState({
        showVasarlas: true,
        showSecondScreen: true,
        tovabbButtonLoading: false,
      });
    });
  }

  handleEsemenyListazas = () => {
    this.setState({ listazasButtonLoading: true, formCurrentEsemeny: null, });
    Services.getRendelesEsemeny(this.state.formCurrentHelyszin.ids, this.dateToTimezone(this.state.rendelesKezdete), this.dateToTimezone(this.state.rendelesVege), this.state.rendelesCime, (err, res) => {
      if (!err) {
        this.setState({
          formCurrentEsemeny: null,
          formEsemenyCards: res[0],
          listazasButtonLoading: false,
        });
      } else {
        this.setState({
          formCurrentEsemeny: null,
          listazasButtonLoading: false,
        });
      }
    });
  }

  newRendelesClick = () => {
    this.setState({ rendelesButtonLoading: true });
    Services.getRendelesHelyszin((err, res) => {
      if (!err) {
        this.setState({ showVasarlas: false }, () => {
          this.setState({
            formCurrentHelyszin: res[0].length === 1 ? res[0][0] : null,
            formCurrentEsemeny: null,
            rendelesKezdete: TimeFormatter.formatDate(Moment()),
            rendelesVege: TimeFormatter.formatDate(Moment()),
            rendelesCime: '',
            formEsemenyCards: [],
            formHelyszinCards: res[0],
            rendelesButtonLoading: false,
            modalFizetes: true
          });
        })
      } else {
        this.setState({
          rendelesButtonLoading: false,
        });
      }
    });
  }

  onHelyszinClick = (item) => {
    this.setState({
      formCurrentHelyszin: item
    });
  }

  onEsemenyClick = (item) => {
    this.setState({
      formCurrentEsemeny: item
    });
  }

  pay = () => {
    this.setState({
      payButtonLoading: true
    })
    Services.rendelesFizetes(this.state.currentId, this.state.formFizetestipus, true, (err, res) => {
      if (!err) {
        this.setState({
          payButtonLoading: false,
          modalPayment: false
        });
        let fileURL = URL.createObjectURL(new Blob([res[0]], { type: 'application/pdf' }));
        this.setState({
          fileURL
        }, () => {
          window.setTimeout(() => {
            window.frames['pdf-area-rendelesek'].focus();
            window.frames['pdf-area-rendelesek'].print();
            window.setTimeout(() => {
              window.close();
            }, 50);
          }, 1000);
        });
        this.props.globals.addSuccess('Sikeres Fizetés!');
        this.listRendeles();
      } else {
        this.setState({
          payButtonLoading: false,
        });
      }
    });
  }

  payWithoutPrint = () => {
    this.setState({
      payButtonLoading: true
    });
    Services.rendelesFizetes(this.state.currentId, this.state.formFizetestipus, false, (err) => {
      if (!err) {
        this.setState({
          payButtonLoading: false,
          modalPayment: false
        });
        this.props.globals.addSuccess('Sikeres Fizetés!');
        this.listRendeles();
      } else {
        this.setState({
          payButtonLoading: false,
        });
      }
    });
  }

  sztornoNyugta = () => {
    this.setState({ sztornoButtonLoading: true });
    Services.sztornoNyugta(this.state.utolsonormalnyugtaid, (err) => {
      if (!err) {
        this.setState({
          sztornoButtonLoading: false,
          utolsonormalnyugtaid: null,
        }, () => {
          this.toggleSztornoModal();
        });
        this.props.globals.addSuccess('Nyugta sztornózva!');
      } else {
        this.setState({
          sztornoButtonLoading: false,
        });
      }
    });
  }


  submitForm = () => {
    const {
      currentId,
      formRendeloNev,
      formRendeloEmail,
      formBizonylatszam,
      formMegjegyzes,
      formFizetesIdo,
      formType
    } = this.state;

    this.setState({
      saveButtonLoading: true
    });

    if (formType === 'FEL') {
      let submitObj = {};
    } else if (formType === 'MOD') {
      let submitObj = {};

      submitObj.id = this.emptyOrNull(currentId);
      submitObj.nev = this.emptyOrNull(formRendeloNev);
      submitObj.email = this.emptyOrNull(formRendeloEmail);
      submitObj.bizonylatSzam = this.emptyOrNull(formBizonylatszam);
      submitObj.megjegyzes = this.emptyOrNull(formMegjegyzes);
      submitObj.fizetesidopont = this.dateToTimezone(formFizetesIdo);

      Services.editRendeles(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Rendelés módosítva!');
          this.setState({
            saveButtonLoading: false
          }, () => {
            this.toggleFormModal();
            this.listRendeles();
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
      });
    }
  }

  tableIconFormatter = (cell, row) => {
    return (
      <div>
         {this.hasRole(['JEGYVASARLAS_RENDELES']) && (
          <React.Fragment>
            <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'view'} onClick={() => this.handleViewClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'view'} delay={50}>
              {'Megtekintés'}
            </UncontrolledTooltip>
          </React.Fragment>
        )}
        {this.hasRole(['JEGYVASARLAS_RENDELES'], true) && (
          <React.Fragment>
            {row.mod && (
              <React.Fragment>
                <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
                  {'Módosítás'}
                </UncontrolledTooltip>
              </React.Fragment>
            )}
            {row.pay && this.props.globals.hasRoleSpec(['JEGYVASARLAS_FOGLALASFIZ'])
              && (this.props.globals.hasRoleSpec(['JEGYVASARLAS_PENZTAR']) || this.props.globals.hasRoleSpec(['JEGYVASARLAS_VEZETO'])) && (
              <React.Fragment>
                <Button className="icon-wallet table-action-icon" id={'action-view-' + cell + 'fizetes'} onClick={() => this.handlePaymentClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'fizetes'} delay={50}>
                  {'Fizetés'}
                </UncontrolledTooltip>
              </React.Fragment>
            )}
            {row.ere && (
              <React.Fragment>
                <Button className="icon-envelope-letter table-action-icon" id={'action-view-' + cell + 'email'} onClick={() => this.handleEmailClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'email'} delay={50}>
                  {'E-mail újraküldés'}
                </UncontrolledTooltip>
              </React.Fragment>
            )}
            {row.prn && (
              <React.Fragment>
                <Button className="icon-printer table-action-icon" id={'action-print-' + cell + 'jegyek'} onClick={() => this.handlePrintJegyekClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-print-' + cell + 'jegyek'} delay={50}>
                  {'Nyomtatás'}
                </UncontrolledTooltip>
              </React.Fragment>
            )}
            {row.del && (
              <React.Fragment>
                <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'file'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'file'} delay={50}>
                  {'Törlés'}
                </UncontrolledTooltip>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }

  tableJegyIconFormatter = (cell, row) => {
    return (
      <div>
        <React.Fragment>
          { row.jegyNyomtathato && (
            <React.Fragment>
              <Button className="icon-printer table-action-icon" id={'action-print-' + cell + 'jegy'} onClick={() => this.handlePrintJegyClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-print-' + cell + 'jegy'} delay={50}>
                {'Nyomtatás'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}

          { row.jegyTorolheto && (
            <React.Fragment>
              <Button className="icon-trash table-action-icon" id={'action-delete-' + cell + 'jegy'} onClick={() => this.handleDeleteJegyClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-delete-' + cell + 'jegy'} delay={50}>
                {'Törlés'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}
        </React.Fragment>
      </div>
    );
  }

  tableBooleanFormatter = (cell) => {
    return cell
      ? <span className="badge badge-success">Igen</span>
      : <span className="badge badge-danger">Nem</span>;
  }

  isSameDay = (d1, d2) => {
    return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
  }

  esemenyFormatter = (cell) => {
    let esemeny = cell.split('¤');
    let backgroundColor = '#63c2de';
    let date = new Date(esemeny[3]);
    if (!this.isSameDay(date, this.now)) {
      if (date < this.now)
        backgroundColor = '#8b8989';
    } else {
      backgroundColor = '#1fd333';
    }
    return (
      <React.Fragment>
        <strong>
          {esemeny[0]}
        </strong>
        <p style={{ marginBottom: 2 }}>
          {esemeny[1]}
        </p>
        <p style={{ marginBottom: 2 }}>
          {esemeny[2]}
        </p>
        <div className="badge" style={{ whiteSpace: 'normal', backgroundColor }}>
          {esemeny[3] && TimeFormatter.formatLLLL(esemeny[3])}
        </div>
      </React.Fragment>
    )
  }

  tableStatusFormatter = (cell, row) => {
    return <div className='badge' style={{ backgroundColor: '#' + row.roc, whiteSpace: 'inherit', display: 'block', color: '#000000' }}>
      {cell}
    </div>;
  }

  styleSzinkod = (szinkod) => {
    return {
      textAlign: 'center',
      whiteSpace: 'pre-line',
      backgroundColor: '#' + szinkod,
    };
  }

  renderFormTitle = () => {
    switch (this.state.formType) {
      case 'FEL':
        return 'Új rendelés létrehozása';
      case 'MOD':
        return 'Rendelés módosítása';
      default:
        return '';
    }
  }

  onXlsxClick = () => {
    this.setState({
      xlsxButtonLoading: true
    });

    let szuroObj = {};
    szuroObj.rid = this.node.filterContext.data.map(b => b.id);
    szuroObj.ekv = {
      sta: this.dateToTimezone(this.state.eloszuresKezdete),
      end: this.dateToTimezone(this.state.eloszuresVege)
    },

    Services.exportRendelesXlsx(szuroObj, (err, res) => {
      if (!err) {
        this.setState({
          xlsxButtonLoading: false
        });
        this.props.globals.addSuccess('Xlsx fájl letöltés indítása...');
        FileSaver.saveAs(new Blob([res[0]], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', responseType: 'arraybuffer' }), 'rendeles_lista_.xlsx');
      } else {
        this.setState({
          xlsxButtonLoading: false
        });
      }
    });
  }

  onReszletesXlsxClick = () => {
    this.setState({
      reszletesXlsxButtonLoading: true
    });

    let szuroObj = {};
    szuroObj.rid = this.node.filterContext.data.map(b => b.id);
    szuroObj.ekv = {
      sta: this.dateToTimezone(this.state.eloszuresKezdete),
      end: this.dateToTimezone(this.state.eloszuresVege)
    },

    Services.exportReszletesRendelesXlsx(szuroObj, (err, res) => {
      if (!err) {
        this.setState({
          reszletesXlsxButtonLoading: false
        });
        this.props.globals.addSuccess('Xlsx fájl letöltés indítása...');
        FileSaver.saveAs(new Blob([res[0]], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', responseType: 'arraybuffer' }), 'reszletes_rendeles_lista_.xlsx');
      } else {
        this.setState({
          reszletesXlsxButtonLoading: false
        });
      }
    });
  }

  renderTable = () => {
    const options = {
      sizePerPage: 50,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '25', value: 25 },
        { text: '50', value: 50 }
      ],
    };


    const columns = [
      {
        dataField: 'ron',
        text: 'Rendelés sorszáma',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'nam',
        text: 'Megrendelő név',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line'
        },
        sort: true,
        hidden: true
      },
      {
        dataField: 'ema',
        text: 'Megrendelő email',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line'
        },
        sort: true,
        hidden: true
      },
      {
        dataField: 'megrendelo',
        text: 'Megrendelő',
        csvExport: false,
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'ena',
        text: 'Esemény neve',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line'
        },
        sort: true,
        hidden: true
      },
      {
        dataField: 'vna',
        text: 'Esemény helyszíne',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line'
        },
        sort: true,
        hidden: true
      },
      {
        dataField: 'hna',
        text: 'Esemény terme',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line'
        },
        sort: true,
        hidden: true
      },
      {
        dataField: 'sta',
        text: 'Esemény kezdete',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line'
        },
        sort: true,
        hidden: true
      },
      {
        dataField: 'helyszin',
        text: 'Esemény',
        csvExport: false,
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
          textAlign: 'center'
        },
        formatter: this.esemenyFormatter,
        // formatter: this.tableBooleanFormatter,
        sort: true
      },
      {
        dataField: 'pri',
        text: 'Rendelés értéke',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
          textAlign: 'center'
        },
        // formatter: this.tableBooleanFormatter,
        sort: true
      },
      {
        dataField: 'jegyek',
        text: 'Jegyek',
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
          textAlign: 'center'
        },
        // formatter: this.tableBooleanFormatter,
        sort: true
      },
      {
        dataField: 'pty',
        text: 'Fizetési mód',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
          textAlign: 'center'
        },
        // formatter: this.tableBooleanFormatter,
        sort: true
      },
      {
        dataField: 'ros',
        text: 'Rendelés állapota',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
          textAlign: 'center'
        },
        // formatter: this.tableBooleanFormatter,
        sort: true,
        formatter: this.tableStatusFormatter,
      },
      {
        dataField: 'rot',
        text: 'Rendelés típusa',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
          textAlign: 'center'
        },
        // formatter: this.tableBooleanFormatter,
        sort: true
      },
      {
        dataField: 'id',
        csvExport: false,
        text: 'Műveletek',
        hidden: !this.hasRole(['JEGYVASARLAS_RENDELES']) && !this.hasRole(['JEGYVASARLAS_RENDELES'], true),
        formatter: this.tableIconFormatter
      }
    ];

    const rowStyle = (row) => {
      const style = {};
      // TODO: publikálás színezése
      if (!row.pub) {
        style.backgroundColor = 'white'; // lightblue
      }
      return style;
    };

    return (
      <div className="animated fadeIn">
        <ToolkitProvider
          exportCSV={{
            onlyExportFiltered: true,
            exportAll: false,
            fileName: 'rendelesek.csv',
            separator: ';',
            blobType: 'application/csv;charset=UTF-8',
            // noAutoBOM: true
          }}
          keyField="id"
          data={this.state.baseJson}
          columns={columns}
        >
          {
            props => (
              <React.Fragment>
                {/* <ExportCSVButton { ...props.csvProps }>Export csv</ExportCSVButton> */}
                <BootstrapTable
                  {...props.baseProps}
                  ref={n => this.node = n}
                  bootstrap4
                  filter={filterFactory()}
                  pagination={paginationFactory(Lib.bootstraptableProps)}
                  wrapperClasses="table-responsive"
                  classes="table-scroll"
                  headerClasses="table-th"
                  noDataIndication="Nincs megjelenítendő adat!"
                  rowStyle={rowStyle}
                />
              </React.Fragment>
            )}
        </ToolkitProvider>
      </div>
    );
  }

  renderEloszures = () => {
    const {
      eloszuresKereses,
      eloszuresHelyszin,
      eloszuresKezdete,
      eloszuresVege,
      eloszuresEloadas,
      eloszuresFizKezdete,
      eloszuresFizVege,
      eloszuresRendelesTipus,
      eloszuresRendelesAllapot,
      eloszuresFizetesimod,
    } = this.state;
    return (
      <RFForm style={{ width: '100%' }} onSubmit={this.listRendeles} className="row">
        <h4>
          {'Keresés  '}
          <span className="badge badge-success" style={{ cursor: 'pointer' }} onClick={() => {
            this.clearFormValues();
          }}><i className="fa fa-eraser" aria-hidden="true" id="filter-button" /></span>
          <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'filter-button'} delay={50}>
            {'Szűrők alaphelyzetbe állitása'}
          </UncontrolledTooltip>
        </h4>

        <RendelesEloszures
          helyszinValue={eloszuresHelyszin}
          helyszinOnChange={this.handleInputHelyszinChange}
          helyszinDisabled={(this.state.eloszuresHelyszinOptions.length < 1) || (this.state.keresesType === 'RENDELES')}
          helyszinOptions={this.state.eloszuresHelyszinOptions}

          kezdeteValue={eloszuresKezdete && new Date(eloszuresKezdete)}
          vegeValue={eloszuresVege && new Date(eloszuresVege)}
          datumDisabled={this.state.keresesType === 'RENDELES'}
          datumOnChange={this.handleDateInputChange}

          keresesValue={eloszuresKereses}
          keresesOnChange={this.handleOszetettInputChange}

          keresesTypeValue={this.state.keresesType}
          keresesTypeOnChange={this.handleRadioInputChange}

          fizKezdeteValue={eloszuresFizKezdete && new Date(eloszuresFizKezdete)}
          fizVegeValue={eloszuresFizVege && new Date(eloszuresFizVege)}
          fizDatumOnChange={this.handleFizDateInputChange}

          eloadasValue={eloszuresEloadas}
          handleInputChange={this.handleInputChange}
          eloadasDisabled={(this.state.eloszuresEloadasOptions.length < 1) || (this.state.keresesType === 'RENDELES')}
          eloadasOptions={this.state.eloszuresEloadasOptions}

          fizetesiModValue={eloszuresFizetesimod}
          fizetesiModDisabled={(this.state.eloszuresFizetesimodOptions.length < 1) || (this.state.keresesType === 'RENDELES')}
          fizetesiModOptions={this.state.eloszuresFizetesimodOptions}

          rendelesTipusValue={eloszuresRendelesTipus}
          rendelesTipusDisabled={(this.state.rendelesTipusOptions.length < 1) || (this.state.keresesType === 'RENDELES')}
          rendelesTipusOptions={this.state.rendelesTipusOptions}

          rendelesAllapotValue={eloszuresRendelesAllapot}
          rendelesAllapotDisabled={(this.state.rendelesAllapotOptions.length < 1) || (this.state.keresesType === 'RENDELES')}
          rendelesAllapotOptions={this.state.rendelesAllapotOptions}
        />
        <div className="row" style={{ marginTop: '20px' }}>
          <div className="col-md-12">
            <Button
              style={{ marginBottom: 8, marginRight: 8 }}
              color="primary"
              className="pull-left table-new-button"
            >
              {'Keresés'}
            </Button>
            {this.hasRole(['JEGYVASRLAS'], true) && (
              <ProgressButton
                style={{ marginBottom: 8, marginRight: 8  }}
                className="pull-left table-new-button"
                color="primary"
                type="button"
                onClick={this.newRendelesClick}
                loading={this.state.rendelesButtonLoading}
              >
                {'Új rendelés'}
              </ProgressButton>
            )}
            {this.props.globals.hasRoleSpec(['JEGYVASARLAS_RIPORT_RENDELES_LISTA']) && (
              <ProgressButton
                style={{ marginBottom: 8, marginRight: 8 }}
                color="primary"
                type="button"
                disabled={this.state.baseJson.length < 1}
                onClick={this.onXlsxClick}
                loading={this.state.xlsxButtonLoading}
                className="pull-left table-new-button"
              >
                {'Export xlsx'}
              </ProgressButton>
            )}
            {this.props.globals.hasRoleSpec(['JEGYVASARLAS_RIPORT_RESZLETES_RENDELES_LISTA']) && (
              <ProgressButton
                style={{ marginBottom: 8 }}
                color="primary"
                type="button"
                disabled={this.state.baseJson.length < 1}
                onClick={this.onReszletesXlsxClick}
                loading={this.state.reszletesXlsxButtonLoading}
                className="pull-left table-new-button"
              >
                {'Részletes xlsx'}
              </ProgressButton>
            )}
          </div>
        </div>
      </RFForm>
    );
  }

  renderFizetesForm = () => {
    const {
      currentId,
      formFizetestipus
    } = this.state;
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12">
            <FormGroup>
              <Label for="formFizetestipus">Fizetés típusa:</Label>
              <Input
                type="select"
                name="formFizetestipus"
                id="formFizetestipus"
                value={formFizetestipus}
                onChange={this.handleInputChange}
              >
                <option value="">Válassz típust...</option>
                {this.state.forFizetestipusOptions}
              </Input>
            </FormGroup>
          </div>
        </div>
      </React.Fragment>
    );
  }

  isActiveHelyszin = (id) => {
    if (this.state.formCurrentHelyszin) {
      if (id === this.state.formCurrentHelyszin.id) return true;
      return false;
    }
    return false;
  }

  isActiveEsemeny = (id) => {
    if (this.state.formCurrentEsemeny) {
      if (id === this.state.formCurrentEsemeny.id) return true;
      return false;
    }
    return false;
  }

  renderHelyszinCards = () => {
    return this.state.formHelyszinCards.map((item) => {
      return <HelyszinItem title={item.nev} active={this.isActiveHelyszin(item.id)} onClick={this.onHelyszinClick} item={item} key={item.id} />
    });
  }

  renderEsemenyCards = () => {
    return this.state.formEsemenyCards.map((item) => {
      return <EsemenyItem id={item.id} title={item.nam} active={this.isActiveEsemeny(item.id)} start={(item.sta ? TimeFormatter.formatLLLL(item.sta) : '')} room={item.hna} info={item.pro} onClick={this.onEsemenyClick} item={item} key={item.id} />
    });
  }

  renderForm = () => {
    const {
      currentId,
      formType,
      formStatusz,
      formRendeloNev,
      formRendeloEmail,
      formRendelesAllapot,
      formRendelesSorszam,
      formEsemenyKezdete,
      formEsemenyNev,
      formTerem,
      formBizonylatszam,
      formMegjegyzes,
      formFizetesIdo,
      formNevEmailKotelezo,
      formFizetestipus,
    } = this.state;

    const titleStyle = {
      marginBottom: 20,
      marginTop: 10
    };

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-4">
              <RFField
                label={'Rendelő neve:'}
                name="formRendeloNev"
                id="formRendeloNev"
                type="text"
                value={formRendeloNev}
                onChange={this.handleInputChange}
                required={formNevEmailKotelezo}
              />
          </div>
          <div className="col-md-4">
              <RFField
                label={'Rendelő e-mail címe:'}
                name="formRendeloEmail"
                id="formRendeloEmail"
                type="text"
                value={formRendeloEmail}
                onChange={this.handleInputChange}
                required={formNevEmailKotelezo}
              />
          </div>
          <div className="col-md-4">
              <RFField
                label={'Státusz: '}
                name="formRendelesAllapot"
                id="formRendelesAllapot"
                type="text"
                value={formRendelesAllapot}
                disabled={formType === 'MOD'}
              />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
              <RFField
                label={'Rendelésszám: '}
                name="formRendelesSorszam"
                id="formRendelesSorszam"
                type="text"
                value={formRendelesSorszam}
                disabled={formType === 'MOD'}
              />
          </div>
          <div className="col-md-6">
              <RFField
                label={'Előadás időpontja: '}
                name="formEsemenyKezdete"
                id="formEsemenyKezdete"
                type="text"
                value={formEsemenyKezdete}
                disabled={formType === 'MOD'}
              />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
              <RFField
                label={'Előadás címe:'}
                name="formEsemenyNev"
                id="formEsemenyNev"
                type="text"
                value={formEsemenyNev}
                disabled={formType === 'MOD'}
              />
          </div>
          <div className="col-md-6">
              <RFField
                label={'Terem: '}
                name="formTerem"
                id="formTerem"
                type="text"
                value={formTerem}
                disabled={formType === 'MOD'}
              />
          </div>
          <div className="col-md-4">
              <RFField
                label={'Bizonylatszám: '}
                name="formBizonylatszam"
                id="formBizonylatszam"
                type="text"
                value={formBizonylatszam}
                onChange={this.handleInputChange}
              />
            {this.state.formRendelesAtutalas && (this.props.globals.hasRoleSpec(['JEGYVASARLAS_FIZMOD_ATUTALAS']) ? (
              <React.Fragment>
                <DatetimePicker
                  label={'Fizetés időpontja:'}
                  containerClassName="organw-date-time"
                  time
                  // format="YYYY-MM-DD HH:mm:ss"
                  messages={{ dateButton: 'dátum', timeButton: 'idő' }}
                  onChange={(e, v) => this.handleFizIdoInputChange(e, v, 'formFizetesIdo')}
                  value={formFizetesIdo !== null ? new Date(formFizetesIdo) : null}
                  name="formFizetesIdo"
                  id="formFizetesIdo"
                />
              </React.Fragment>
            ) : (
                <RFField
                  label={'Fizetés időpontja: '}
                  name="formFizetesIdo"
                  id="formFizetesIdo"
                  type="text"
                  value={formFizetesIdo && TimeFormatter.formatDateTime(formFizetesIdo)}
                  disabled={formType === 'MOD'}
                />
            ))}
          </div>
          <div className="col-md-8">
              <RFField
                label={'Megjegyzés: '}
                name="formMegjegyzes"
                id="formMegjegyzes"
                type="textarea"
                value={formMegjegyzes}
                onChange={this.handleInputChange}
              />
          </div>
        </div>
        <div className="row" style={{ borderBottom: '1px solid #dee2e6', marginBottom: 15 }}>
          <div className="col-md-12" style={{ minWidth: '100%', maxWidth: '100%', justifyContent: 'flex-end' }}>
            {this.state.utolsonormalnyugtaid && this.props.globals.hasRole(['SZAMLAZAS_NYUGTA'], true) && (
              <Button
                type="button"
                color="primary"
                className="btn-cursor-pointer pull-left"
                onClick={this.toggleSztornoModal}
                style={{
                  marginBottom: 10,
                  marginRight: 6
                }}
              >
                Nyugta sztornózása
              </Button>
            )}
            <ProgressButton
              className="btn-cursor-pointer pull-right"
              color="primary"
              loading={this.state.saveButtonLoading}
              onClick={this.submitForm}
              style={{
                marginBottom: 10,
                marginRight: 6
              }}
              >
              {'Mentés'}
            </ProgressButton>
            <Button
              type="button"
              color="secondary"
              style={{
                marginBottom: 10,
                marginRight: 6
                }}
              className="btn-cursor-pointer pull-right"
              onClick={this.toggleFormModal}
            >
              Mégsem
            </Button>
          </div>
        </div>
        <div className="col-md-12">
          <h5>Jegyek:</h5>
        </div>
        <div>
          <div className="col-md-12">
            {
              {
                LOAD: <Loader />,
                DATA: (
                  <DataEmptyState hasImage subtitle="Vigyél fel új tételt!" />
                ),
                NETW: (
                  <NetworkEmptyState
                    hasImage
                    submitClick={() => {
                      // this.listHelyszin();
                    }}
                  />
                ),
                TABL: this.renderFoglalasTable()
              }[this.state.tableStatus]
            }
          </div>
        </div>
      </React.Fragment>
    );
  };

  getKedvezmenyCell = (kedvezmenyNev, kedvezmenyAzon) => {
    let result = '';

    if (kedvezmenyNev) {
      result += kedvezmenyNev;
    }

    if (kedvezmenyAzon) {
      result +=  (' (' + kedvezmenyAzon + ')');
    }

    return result;
  }

  renderView = () => {
    const {
      formRendeloNev,
      formRendeloEmail,
      formRendelesAllapot,
      formRendelesSorszam,
      formEsemenyKezdete,
      formEsemenyNev,
      formTerem,
      formBizonylatszam,
      formMegjegyzes,
      formFizetesIdo,
      formJegyadatok,
      viewRendelesIdopont,
      viewRogzitesUser,
      viewModositasIdopont,
      viewModositasUser,
      viewFizetesIdopont,
      viewFizetesUser,
      nyugtak,
    } = this.state;

    let vanEnter = this.state.formMegjegyzes.indexOf('\n') >= 0;

    return (
      <React.Fragment>
        <iframe name="pdf-area-nyugtak" id="pdf-area-nyugtak" src={this.state.fileURLNyugta} style={{ visibility: 'hidden', height: 0, width: 0 }} />
        <div className="row">
          <div className={nyugtak ? 'col-md-6' : 'col-md-12'}>
            <h6>Rendelés adatok:</h6>
            <b>Rendelő neve: </b>{formRendeloNev}<br />
            <b>Rendelő e-mail címe: </b>{formRendeloEmail}<br />
            <b>Státusz: </b>{formRendelesAllapot}<br />
            <b>Rendelésszám: </b>{formRendelesSorszam}<br />
            <b>Előadás időpontja: </b>{formEsemenyKezdete && TimeFormatter.format(formEsemenyKezdete, 'LLLL')}<br />
            <b>Előadás címe: </b>{formEsemenyNev}<br />
            <b>Terem: </b>{formTerem}<br />
            <b>Bizonylatszám: </b>{formBizonylatszam}<br />
            <br />
            {vanEnter ? (
              <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                <b>Megjegyzés:</b><br />{formMegjegyzes}<br />
              </div>
            ) : (
              <div style={{ wordBreak: 'break-word' }}>
                <b>Megjegyzés: </b>{formMegjegyzes}<br />
              </div>
            )}
            <br />
            {this.state.formRendelesAtutalas && (
            <React.Fragment>
              <b>Fizetés időpontja: </b>{formFizetesIdo !== null ? TimeFormatter.format(formFizetesIdo, 'LLLL') : ''}<br />
              <br />
            </React.Fragment>
            )}
            <b>Rendelés / rögzítés időpontja: </b>{viewRendelesIdopont && TimeFormatter.format(viewRendelesIdopont, 'LLLL')}<br />
            <b>Rögzitő felhasználó: </b>{viewRogzitesUser}<br />
            <b>Módosítás időpontja: </b>{viewModositasIdopont && TimeFormatter.format(viewModositasIdopont, 'LLLL')}<br />
            <b>Módosító felhasználó: </b>{viewModositasUser}<br />
            <b>Fizetés időpontja: </b>{viewFizetesIdopont && TimeFormatter.format(viewFizetesIdopont, 'LLLL')}<br />
            <b>Értékesítő felhasználó: </b>{viewFizetesUser}<br />
            <br />
          </div>
          {nyugtak && (
            <div className="col-md-6">
              <h6>Nyugták:</h6>
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">Időpont:</th>
                    <th scope="col">Bizonylatszám:</th>
                    <th scope="col">Állapot:</th>
                    <th scope="col">Műveletek:</th>
                  </tr>
                </thead>
                <tbody>
                  {nyugtak.map((item, i) => {
                    return (
                      <tr key={item.id} style={{ whiteSpace: 'pre-wrap', fontSize: 12 }}>
                        <td style={{ opacity: i < nyugtak.length - 1 ? 0.5 : 1 }}>{item.rogzitesidopont && TimeFormatter.format(item.rogzitesidopont, 'YYYY-MM-DD LTS')}</td>
                        <td style={{ opacity: i < nyugtak.length - 1 ? 0.5 : 1 }}>{item.bizonylatszam}</td>
                        <td style={{ opacity: i < nyugtak.length - 1 ? 0.5 : 1 }}>{item.tipus}</td>
                        <td>
                          <React.Fragment>
                            <Button className="icon-eye table-action-icon" id={'action-view-' + item.id + 'nyugta'} onClick={() => this.handleNyugtaViewClick(item.id)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                            <Button className="icon-printer table-action-icon" id={'action-print-' + item.id + 'nyugta'} onClick={() => this.handlePrintNyugta(item.id)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-print-' + item.id + 'nyugta'} delay={50}>
                              {'Nyomtatás'}
                            </UncontrolledTooltip>
                            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + item.id + 'nyugta'} delay={50}>
                              {'Megtekintés'}
                            </UncontrolledTooltip>
                          </React.Fragment>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-md-12">
            <h6>Jegy adatok:</h6>
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">Sorszám:</th>
                    <th scope="col">Hely:</th>
                    <th scope="col">Jegytípus:</th>
                    <th scope="col">Jegyár:</th>
                    <th scope="col">Kedvezmény:</th>
                    <th scope="col">Kényelmi díj:</th>
                    {this.props.globals.hasRoleSpec(['JEGYVASARLAS_RENDELES_ERVENYESITES']) && (
                      <React.Fragment>
                        <th scope="col">Érvényesítés időpontja,<br /> felhasználó:</th>
                      </React.Fragment>
                    )}
                    {this.props.globals.hasRoleSpec(['JEGYVASARLAS_RENDELES_TORLES']) && (
                      <React.Fragment>
                        <th scope="col">Törlés időpontja,<br /> felhasználó, oka:</th>
                      </React.Fragment>
                    )}
                    <th scope="col">Állapot:</th>
                  </tr>
                </thead>
                <tbody>
                  {formJegyadatok.map((item) => {
                    return (
                      <tr key={item.id} style={{ whiteSpace: 'pre-wrap', fontSize: 12 }}>
                        <th scope="row">{item.jegySorszam}</th>
                        <td>{item.jegyHely}</td>
                        <td>{item.jegyTipus}</td>
                        <td>{NumberFormatter.formatterSpaceOsszegPenznem(item.kenyelmiDij ? item.jegyAr - item.kenyelmiDij : item.jegyAr, null, item.jegyPenznem)}</td>
                        <td>{this.getKedvezmenyCell(item.jegyKedvezmenyNev, item.jegyKedvezmenyAzonosito)}</td>
                        <td>{item.kenyelmiDij && NumberFormatter.formatterSpaceOsszegPenznem(item.kenyelmiDij, null, item.jegyPenznem)}</td>
                        {this.props.globals.hasRoleSpec(['JEGYVASARLAS_RENDELES_ERVENYESITES']) && (
                          <React.Fragment>
                            <td>
                              {item.jegyErvenyesitesIdopont && TimeFormatter.format(item.jegyErvenyesitesIdopont, 'YYYY-MM-DD LTS')}
                              <br />
                              {item.jegyErvenyesitesUser}
                            </td>
                          </React.Fragment>
                        )}
                        {this.props.globals.hasRoleSpec(['JEGYVASARLAS_RENDELES_TORLES']) && (
                          <React.Fragment>
                            <td>
                              {item.jegyTorlesIdopont && TimeFormatter.format(item.jegyTorlesIdopont, 'YYYY-MM-DD LTS')}
                              <br />
                              {item.torlesOka}
                            </td>
                          </React.Fragment>
                        )}
                        <td>{item.jegyAllapot}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  handleNyugtaViewClick = (id) => {
    this.setState({ dataNyugtaLoaded: false });
    Services.getNyugta(id, (err, res) => {
      if (!err) {
        this.setState({
          nyugtaViewObj: res[0],
          dataNyugtaLoaded: true
        });
      }
    });
    this.toggleNyugtaMegtekintes();
  }

  tableKedvezmenyFormatter = (cell, row) => {
    return this.getKedvezmenyCell(row.jegyKedvezmenyNev, row.jegyKedvezmenyAzonosito);
  }

  tableJegyArFormatter = (cell, row) => {
    return NumberFormatter.formatterSpaceOsszegPenznem(row.kenyelmiDij ? row.jegyAr - row.kenyelmiDij : row.jegyAr, null, row.jegyPenznem);
  }

  tableKenyelmiDijFormatter = (cell, row) => {
    if (!row.kenyelmiDij)
      return;

    return NumberFormatter.formatterSpaceOsszegPenznem(row.kenyelmiDij, null, row.jegyPenznem);
  }

  renderFoglalasTable = () => {
    const columns = [
      {
        dataField: 'jegySorszam',
        text: 'Jegy \x0D sorszáma:',
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
      },
      {
        dataField: 'jegyHely',
        text: 'Hely:',
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
      },
      {
        dataField: 'jegyTipus',
        text: 'Jegytípus:',
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
      },
      {
        dataField: 'jegyAr',
        text: 'Jegyár:',
        formatter: this.tableJegyArFormatter,
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
      },
      {
        dataField: 'jegyKedvezmenyAzonosito',
        text: 'Kedvezmény:',
        formatter: this.tableKedvezmenyFormatter,
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
      },
      {
        dataField: 'kenyelmiDij',
        text: 'Kényelmi díj:',
        formatter: this.tableKenyelmiDijFormatter,
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
      },
      {
        dataField: 'jegyAllapot',
        text: 'Állapot:',
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.tableJegyIconFormatter
      }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.formJegyadatok}
          columns={columns}
          headerClasses="table-th"
          // cellEdit={ cellEditFactory({ mode: 'click' }) }
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  };

  renderNyugtaAdatok = () => {
    let ny = this.state.nyugtaViewObj;
    return this.state.dataNyugtaLoaded ? (
      <div>
        <h6>Kibocsátó adatok</h6>
        <b>Név: </b>
        {ny && ny.cegnev}
        <br />
        <b>Cím: </b>
        {ny && ny.cegcim}
        <br />
        <b>Adószám: </b>
        {ny && ny.cegadoszam}
        <br />
        <br />
        <h6>Nyugta adatok</h6>
        <b>Állapot: </b>
        {ny && ny.tipus}
        <br />
        <b>Bizonylatszám: </b>
        {ny && ny.bizonylatszam}
        <br />
        <b>Összeg: </b>
        {ny && ny.osszeg && NumberFormatter.formatterSpaceOsszeg(ny.osszeg) + ' ' + ny.penznem}
        <br />
        <br />
        <b>Nyugta kelte: </b>
        {ny && ny.rogzitesidopont && TimeFormatter.formatLLLL(ny.rogzitesidopont)}
        <br />
        <b>Rögzítő felhasználó: </b>
        {ny && ny.rogzuser}
        <br />
        <br />
        <b>Sztornózás kelte: </b>
        {ny && ny.sztornoidopont && TimeFormatter.formatLLLL(ny.sztornoidopont)}
        <br />
        <b>Sztornózó felhasználó: </b>
        {ny && ny.sztornouser}
        <br />
      </div>
    ) : <Loader />;
  }

  render() {
    const { showSecondScreen } = this.state;

    return (
      <Localization date={localizer}>
        <React.Fragment>
          <div>
            {/* <Button>Második kijelzős mód</Button> */}
            <iframe name="pdf-area-rendelesek" id="pdf-area-rendelesek" src={this.state.fileURL} style={{ visibility: 'hidden', height: 0, width: 0 }} />
            {this.renderEloszures()}
            <div>
              {{
                QUERY: (<QueryEmptyState hasImage />),
                LOAD: (<Loader />),
                DATA: (<DataEmptyState
                  hasImage
                  subtitle="Vigyél fel új tételt!"
                />),
                NETW: (<QueryEmptyState
                  hasImage
                  submitClick={() => { this.listRendeles(); }}
                />),
                TABL: (this.renderTable())
              }[this.state.tableStatus]}
            </div>
          </div>
          <Modal isOpen={this.state.modalForm} toggle={this.toggleFormModal} backdrop="static" size="lg">
            <RFForm
              onSubmit={this.submitForm}
              // title={this.renderFormTitle()}
              // tagProps={{ isOpen: this.state.modalForm, toggle: this.toggleFormModal, backdrop: 'static',  size: 'lg' }}
              // footer={
              //   <React.Fragment>
              //     <ProgressButton
              //       className="btn-cursor-pointer pull-right"
              //       color="primary"
              //       loading={this.state.saveButtonLoading}
              //       onClick={this.submitForm}
              //       style={{
              //         marginBottom: 10,
              //         marginRight: 6
              //       }}
              //     >
              //       {'Mentés'}
              //     </ProgressButton>
              //     {this.state.utolsonormalnyugtaid && this.hasRole(['SZAMLAZAS_NYUGTA'], true) && (
              //       <Button
              //         type="button"
              //         color="primary"
              //         className="btn-cursor-pointer pull-left"
              //         onClick={this.toggleSztornoModal}
              //         style={{
              //           marginBottom: 10,
              //           marginRight: 6
              //         }}
              //       >
              //         Nyugta sztornózása
              //       </Button>
              //     )}
              //     <Button type="button" color="secondary" className="btn-cursor-pointer pull-right" onClick={this.toggleFormModal}>Mégsem</Button>
              //   </React.Fragment>
              // }
            >
              <ModalHeader>{this.renderFormTitle()}</ModalHeader>
              <ModalBody>
                {{
                  LOAD: (<Loader />),
                  NETW: (<NetworkEmptyState
                    hasImage
                    submitClick={() => { this.getRendeles(); }}
                  />),
                  DATA: (this.renderForm())
                }[this.state.formStatus]}
              </ModalBody>
              <ModalFooter>
              {/* <React.Fragment>
                  <ProgressButton
                    className="btn-cursor-pointer pull-right"
                    color="primary"
                    loading={this.state.saveButtonLoading}
                    onClick={this.submitForm}
                    style={{
                      marginBottom: 10,
                      marginRight: 6
                    }}
                  >
                    {'Mentés'}
                  </ProgressButton>
                  {this.state.utolsonormalnyugtaid && this.hasRole(['SZAMLAZAS_NYUGTA'], true) && (
                    <Button
                      type="button"
                      color="primary"
                      className="btn-cursor-pointer pull-left"
                      onClick={this.toggleSztornoModal}
                      style={{
                        marginBottom: 10,
                        marginRight: 6
                      }}
                    >
                      Nyugta sztornózása
                    </Button>
                  )}
                  <Button type="button" color="secondary" className="btn-cursor-pointer pull-right" onClick={this.toggleFormModal}>Mégsem</Button>
                </React.Fragment> */}
                <Button
                  onClick={this.toggleFormModal}
                >
                  {'Bezárás'}
                </Button>
                {/* <Button
                  color="primary"
                  type='submit'
                >
                  {'Mentés'}
                </Button>
                <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleFormModal}>Bezárás</Button> */}
              </ModalFooter>
            </RFForm>
            </Modal>
            {/* <Modal isOpen={this.state.modalJegyDelete} toggle={this.toggleDeleteJegyModal} backdrop="static"> */}
              <RFForm
                onSubmit={this.deleteJegy}
                modalInsert
                title={'Törlés'}
                tagProps={{ isOpen: this.state.modalJegyDelete, toggle: this.toggleDeleteJegyModal, backdrop: 'static' }}
                footer={
                  <React.Fragment>
                    <ProgressButton
                      className="btn-cursor-pointer"
                      color="primary"
                      loading={this.state.deleteJegyButtonLoading}
                    >
                      {'Törlés'}
                    </ProgressButton>
                    <Button type="button" color="secondary" onClick={this.toggleDeleteJegyModal}>Mégsem</Button>
                  </React.Fragment>
                }
              >
                {/* <ModalHeader>Törlés</ModalHeader>
                <ModalBody> */}
                  <div className="delete-title-text" style={{ marginBottom: 12 }}>Valóban törölni kívánod a kiválasztott jegyet?</div>
                  {this.state.hasTorlesOka && (
                    <FormGroup>
                      {/* <Label for="formTorlesJegyOka">Törlés oka: *</Label> */}
                      <RFField label={'Törlés oka: *'} name="formTorlesJegyOka" id="formTorlesJegyOka" required value={this.state.formTorlesJegyOka} onChange={this.handleInputChange} />
                    </FormGroup>
                  )}
                {/* </ModalBody>
                <ModalFooter>
                  <ProgressButton
                    className="btn-cursor-pointer"
                    color="primary"
                    // onClick={() => this.deleteRendeles()}
                    loading={this.state.deleteJegyButtonLoading}
                  >
                    {'Törlés'}
                  </ProgressButton>
                  <Button type="button" color="secondary" onClick={this.toggleDeleteJegyModal}>Mégsem</Button>
                </ModalFooter> */}
              </RFForm>
            {/* </Modal> */}
          {/* </Modal> */}
          <Modal isOpen={this.state.modalView} toggle={this.toggleViewModal} backdrop="static" size="lg">
            <ModalHeader>Megtekintés</ModalHeader>
            <ModalBody>
              {{
                LOAD: (<Loader />),
                NETW: (<NetworkEmptyState
                  hasImage
                  submitClick={() => { this.getRendelesView(); }}
                />),
                DATA: (this.renderView())
              }[this.state.viewStatus]}
            </ModalBody>
            <ModalFooter>
              <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleViewModal}>Bezárás</Button>
            </ModalFooter>
          </Modal>
          {/* <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static"> */}
            <RFForm
              onSubmit={this.deleteRendeles}
              modalInsert
              title={'Törlés'}
              tagProps={{ isOpen: this.state.modalDelete, toggle: this.toggleDeleteModal, backdrop: 'static' }}
              footer={
                <React.Fragment>
                  <ProgressButton
                    className="btn-cursor-pointer"
                    color="primary"
                    onClick={() => this.deleteRendeles()}
                    loading={this.state.deleteButtonLoading}
                  >
                    {'Törlés'}
                  </ProgressButton>
                  <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
                </React.Fragment>
              }
            >
              {/* <ModalHeader>Törlés</ModalHeader>
              <ModalBody> */}
                <div className="delete-title-text" style={{ marginBottom: 12 }}>Valóban törölni kívánod a kiválasztott rendelést?</div>
                {this.state.hasTorlesOka && (
                  <FormGroup>
                    {/* <Label for="formTorlesOka">Törlés oka: *</Label> */}
                    <RFField label={'Törlés oka: *'} name="formTorlesOka" id="formTorlesOka" required value={this.state.formTorlesOka} onChange={this.handleInputChange} />
                  </FormGroup>
                )}
              {/* </ModalBody>
              <ModalFooter>
                <ProgressButton
                  className="btn-cursor-pointer"
                  color="primary"
                  // onClick={() => this.deleteRendeles()}
                  loading={this.state.deleteButtonLoading}
                >
                  {'Törlés'}
                </ProgressButton>
                <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
              </ModalFooter> */}
            </RFForm>
          {/* </Modal> */}
          <Modal isOpen={this.state.modalEmail} toggle={this.toggleEmailModal} backdrop="static">
            <ModalHeader>Email újraküldés</ModalHeader>
            <ModalBody>
              <FormGroup>
                <Label for="currentEmail">Email cím:</Label>
                <Input type="email" name="currentEmail" id="currentEmail" value={this.state.currentEmail} onChange={this.handleInputChange} />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                onClick={() => this.resendEmail()}
                loading={this.state.emailButtonLoading}
              >
                {'Újraküldés'}
              </ProgressButton>
              <Button type="button" color="secondary" onClick={this.toggleEmailModal}>Mégsem</Button>
            </ModalFooter>
          </Modal>
          <Modal isOpen={this.state.modalPayment} toggle={this.togglePaymentModal} backdrop="static">
            <ModalHeader>Rendelés fizetése</ModalHeader>
            <ModalBody>
              {{
                LOAD: (<Loader />),
                NETW: (<NetworkEmptyState
                  hasImage
                  submitClick={() => {}}
                />),
                DATA: (this.renderFizetesForm())
              }[this.state.formFizetesStatus]}
            </ModalBody>
            <ModalFooter>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                onClick={() => this.pay()}
                loading={this.state.payButtonLoading}
              >
                {'Fizetés'}
              </ProgressButton>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                onClick={() => this.payWithoutPrint()}
                loading={this.state.payButtonLoading}
              >
                {'Fizetés nyomtatás nélkül'}
              </ProgressButton>
              <Button type="button" color="secondary" onClick={this.togglePaymentModal}>Mégsem</Button>
            </ModalFooter>
          </Modal>
          <Modal isOpen={this.state.modalFizetes} toggle={this.toggleFizetesModal} size="lg" backdrop="static">
            <ModalHeader>Új rendelés</ModalHeader>
            <ModalBody>
              {this.state.showVasarlas ? <JegyvasarlasContent id={this.state.formCurrentEsemeny.eid} globals={this.props.globals} /> : (
                <React.Fragment>
                  <div className="row">
                    <div className="col-md-12">
                      <h3>Helyszínek:</h3>
                    </div>
                  </div>
                  <div className="row">
                    {this.renderHelyszinCards()}
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <DatetimePicker
                        label={'Esemény kezdete:'}
                        containerClassName="organw-date-time"
                        time={false}
                        // format="YYYY-MM-DD"
                        messages={{ dateButton: 'dátum', timeButton: 'idő' }}
                        onChange={(e, v) => this.handleDateInputChange(e, v, 'rendelesKezdete')}
                        value={this.state.rendelesKezdete && new Date(this.state.rendelesKezdete)}
                        name="rendelesKezdete"
                        id="rendelesKezdete"
                      />
                    </div>
                    <div className="col-md-3">
                      <DatetimePicker
                        label={'Esemény kezdete:'}
                        containerClassName="organw-date-time"
                        time={false}
                        // format="YYYY-MM-DD"
                        messages={{ dateButton: 'dátum', timeButton: 'idő' }}
                        onChange={(e, v) => this.handleDateInputChange(e, v, 'rendelesVege')}
                        value={this.state.rendelesVege && new Date(this.state.rendelesVege)}
                        name="rendelesVege"
                        id="rendelesVege"
                      />
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label for="rendelesCime">Esemény címe:</Label>
                        <Input type="text" name="rendelesCime" id="rendelesCime" value={this.state.rendelesCime} onChange={this.handleInputChange} />
                      </FormGroup>
                    </div>
                    <div className="col-md-2">
                      <ProgressButton
                        style={{ marginBottom: 0, marginTop: 27 }}
                        className="pull-left table-new-button"
                        onClick={this.handleEsemenyListazas}
                        color="primary"
                        type="button"
                        loading={this.state.listazasButtonLoading}
                        disabled={!this.state.formCurrentHelyszin}
                      >
                        {'Listázás'}
                      </ProgressButton>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <h3>Események:</h3>
                    </div>
                  </div>
                  <div className="row">
                    {this.renderEsemenyCards()}
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <ProgressButton
                        style={{ marginBottom: 0, marginTop: 27 }}
                        className="pull-right table-new-button"
                        disabled={!this.state.formCurrentEsemeny}
                        loading={this.state.tovabbButtonLoading}
                        onClick={this.handleEloadasListazas}
                        color="primary"
                        type="button"
                      >
                        {'Tovább'}
                      </ProgressButton>
                    </div>
                  </div>
                </React.Fragment>
              )}
            </ModalBody>
            <ModalFooter>
              <Button type="button" color="secondary" onClick={this.toggleFizetesModal}>Bezárás</Button>
            </ModalFooter>
          </Modal>
          {/* <Modal isOpen={this.state.modalSztorno} toggle={this.toggleSztornoModal} backdrop="static"> */}
            <RFForm
              onSubmit={this.sztornoNyugta}
              modalInsert
              title={'Nyugta sztornózása'}
              tagProps={{ isOpen: this.state.modalSztorno, toggle: this.toggleSztornoModal, backdrop: 'static' }}
              footer={
                <React.Fragment>
                  <ProgressButton
                    className="btn-cursor-pointer"
                    color="primary"
                    loading={this.state.sztornoButtonLoading}
                  >
                    {'Sztornózás'}
                  </ProgressButton>
                  <Button type="button" color="secondary" onClick={this.toggleSztornoModal}>Mégsem</Button>
                </React.Fragment>
              }
            >
              {/* <ModalHeader>Nyugta sztornózása</ModalHeader>
              <ModalBody> */}
                <div className="sztorno-title-text" style={{ marginBottom: 12 }}>Valóban sztornózni kívánod a rendeléshez tartozó nyugtát?</div>
              {/* </ModalBody>
              <ModalFooter>
                <ProgressButton
                  className="btn-cursor-pointer"
                  color="primary"
                  // onClick={() => this.deleteRendeles()}
                  loading={this.state.sztornoButtonLoading}
                >
                  {'Sztornózás'}
                </ProgressButton>
                <Button type="button" color="secondary" onClick={this.toggleSztornoModal}>Mégsem</Button>
              </ModalFooter> */}
            </RFForm>
          {/* </Modal> */}
          <Modal isOpen={this.state.modalNyugtaMegtekintes} toggle={this.toggleNyugtaMegtekintes} className={this.props.className} backdrop="static">
            <ModalHeader>Megtekintés</ModalHeader>
            <ModalBody>{this.state.modalNyugtaMegtekintes ? this.renderNyugtaAdatok() : <div />}</ModalBody>
            <ModalFooter><Button type="button" color="primary" onClick={this.toggleNyugtaMegtekintes} className="btn-cursor-pointer">Bezárás</Button></ModalFooter>
          </Modal>
        </React.Fragment>
      </Localization>
    );
  }
}

RendelesekContent.propTypes = {
  active: PropTypes.bool,
  globals: PropTypes.object
};

export default RendelesekContent;
